import { Form, Formik } from "formik";
import FormInput from "../../../../Universal/FormInput.component";
import "../../../../../styles/ComponentsStyles/Setting/Profile/SetupTeam/TemInfo.style.css";
import ProfileViewer from "../../../../Universal/Profiles/ProfileViewer.component";
import { ReactComponent as BatchIcon } from "../../../../../assets/Icons/Setting/Profile/TeamBatch.svg";
import SecondModal from "../../../../Universal/SecondModal.component";
import { useEffect, useState } from "react";
import Title from "../../../../Universal/Title.component";
import SearchIcon from "../../../../../assets/Icons/Universal/Search.svg";
import FilterBtn from "../../../../Universal/FilterBtn.component";
import ScrollableTable from "../../../../Universal/Tables/ScrollableTable.component";
const TeamInfoForm = ({
  _data,
  isEdit = false,
  outPutData,
  isNewFields = false,
}) => {
  const [modalStatus, setModalStatus] = useState(false);
  const [modalSearchInput, setModalSearchInput] = useState("");
  const [initialData, setInitialData] = useState({});
  // eslint-disable-next-line
  const [fetchModalData, setFetchModalData] = useState([
    {
      name: "Toufik Alam",
      id: "SM0523019",
      class: "5/A",
      designation: "Students",
      image: "https://randomuser.me/api/portraits/men/10.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Mustak Ahamed",
      id: "SM0721011",
      class: "5/A",
      designation: "Teacher",
      image: "https://randomuser.me/api/portraits/men/11.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Ayesha Siddiqua",
      id: "SM0621093",
      class: "6/B",
      designation: "Staffs",
      image: "https://randomuser.me/api/portraits/women/12.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Rihan Ahmed",
      id: "SM0532044",
      class: "5/A",
      designation: "Students",
      image: "https://randomuser.me/api/portraits/men/13.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Sneha Roy",
      id: "SM0418095",
      class: "4/C",
      designation: "Students",
      image: "https://randomuser.me/api/portraits/women/14.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Arjun Mehra",
      id: "SM0812041",
      class: "8/A",
      designation: "Teacher",
      image: "https://randomuser.me/api/portraits/men/15.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Fatima Noor",
      id: "SM0321099",
      class: "3/B",
      designation: "Management",
      image: "https://randomuser.me/api/portraits/women/16.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Zayan Khan",
      id: "SM0712038",
      class: "7/B",
      designation: "Staffs",
      image: "https://randomuser.me/api/portraits/men/17.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Priya Sharma",
      id: "SM0611077",
      class: "6/A",
      designation: "Students",
      image: "https://randomuser.me/api/portraits/women/18.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
    {
      name: "Aditya Verma",
      id: "SM0515090",
      class: "5/C",
      designation: "Management",
      image: "https://randomuser.me/api/portraits/men/19.jpg",
      isCaptain: false,
      isViceCaptain: false,
    },
  ]);

  const [modalData, setModalData] = useState([]);
  const [modalSelectedData, setModalSelectedData] = useState([]);
  const [modalProfileFilter, setModalProfileFilter] = useState("");

  const handelAddProfile = (id) => {
    const selected = modalData.find((data) => data.id === id);
    setModalSelectedData((prev) => {
      const alreadyExists = prev.some((item) => item.id === id);
      if (!alreadyExists && selected) {
        return [...prev, selected];
      } else {
        return prev.filter((item) => item.id !== id);
      }
    });
  };

  useEffect(() => {
    setModalData(fetchModalData);
  }, [fetchModalData]);
  const searchData = (filterTxt) => {
    if (filterTxt === "") {
      return setModalData(fetchModalData);
    }
    const keyword = filterTxt?.toLowerCase()?.trim();
    const filteredData = fetchModalData.filter(
      (data) =>
        data?.id?.toLowerCase() === keyword ||
        data?.name?.toLowerCase() === keyword
    );
    setModalData(filteredData);
  };

  useEffect(() => {
    const filteredData = fetchModalData.filter((data) =>
      modalProfileFilter.length === 0
        ? true // if no filters selected, return all
        : modalProfileFilter.includes(data.role)
    );

    setModalData(filteredData);
  }, [modalProfileFilter, fetchModalData]);

  useEffect(() => {
    setInitialData(_data);
    setModalSelectedData(_data?.teamMembers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log(isEdit);
  return (
    <div
      className="h-fit flex-col align-left justify-start g-2 p-2 back-white radius-10"
      style={{ width: "24rem", borderTop: "8px solid var(--blueColor1)" }}
    >
      <SecondModal isOpen={modalStatus} onClose={setModalStatus} isCrossBtn>
        <div
          className="flex-col align-left justify-start g-1"
          style={{ width: "30rem" }}
        >
          <div className="flex-row align-center justify-between">
            <Title>Add members</Title>
          </div>
          <div className="w-full flex-row align-center justify-between">
            <div className="searchInputContainer">
              <input
                type="text"
                className="pageHeaderInput"
                placeholder="Type for search"
                onChange={(e) => setModalSearchInput(e.target.value)}
              />
              <button
                className="searchBtn"
                onClick={() => searchData(modalSearchInput)}
              >
                <img src={SearchIcon} alt="searchBtn" />
              </button>
            </div>

            <FilterBtn
              btnTitle={"Filter"}
              filterArray={["Students", "Teacher", "Staffs", "Management"]}
              setFilteredData={(val) => setModalProfileFilter(val)}
              filteredData={modalProfileFilter}
            />
          </div>

          <div
            className="flex-col align-left justify-start scroll-y w-full pr-1"
            style={{ height: "70vh" }}
          >
            <ScrollableTable
              thead={["Candidates", "Attributes", "Positions", "Add"]}
              className="profileAddModalTable"
            >
              {modalData?.map((data) => {
                return (
                  <tr>
                    <td>
                      <ProfileViewer
                        name={data?.name}
                        _id={data?.id}
                        imageHeight={"3rem"}
                        imageWidth={"3rem"}
                        imageSource={data?.image}
                        className={"w-fit"}
                      />
                    </td>
                    <td className="t-13 poppins color-greenColor">
                      {data?.class}
                    </td>
                    <td className="t-13 poppins color-greenColor">
                      {data?.role}
                    </td>
                    <td>
                      <button
                        type="button"
                        className={
                          modalSelectedData?.find(
                            (user) => user.id === data?.id
                          )
                            ? "profileAddedBtn"
                            : `profileAddBtn`
                        }
                        onClick={() => handelAddProfile(data?.id)}
                      >
                        Add
                      </button>
                    </td>
                  </tr>
                );
              })}
            </ScrollableTable>
          </div>
        </div>
      </SecondModal>
      <h3 className="weight-500 t-18 poppins-medium color-textColor">
        {isNewFields ? " Create team" : "Update team"}
      </h3>
      <div
        className="w-full flex-col align-left justify-start scroll-y pr-05"
        style={{ maxHeight: "26rem" }}
      >
        <Formik
          initialValues={{
            ...initialData,
            teamMembers: modalSelectedData && modalSelectedData,
          }}
          onSubmit={(values) => {
            outPutData(values);
            console.log("submit");
          }}
          enableReinitialize
        >
          {({ values, setFieldValue, touched, errors }) => {
            const handelSetCaptain = (id) => {
              const updatedMembers = values?.teamMembers?.map((member) => {
                if (member.id === id) {
                  return {
                    ...member,
                    isCaptain: true,
                    isViceCaptain: false,
                  };
                } else {
                  return {
                    ...member,
                    isCaptain: false,
                    isViceCaptain: false,
                  };
                }
              });
              setFieldValue("teamMembers", updatedMembers);
            };

            const handelSetViceCaptain = (id) => {
              const updatedMembers = values?.teamMembers?.map((member) => {
                if (member?.id === id) {
                  return {
                    ...member,
                    isViceCaptain: true,
                  };
                } else {
                  return member;
                }
              });
              setFieldValue("teamMembers", updatedMembers);
            };

            const isCaptainSelected = values?.teamMembers?.some(
              (m) => m?.isCaptain
            );
            const isViceCaptainSelected = values?.teamMembers?.some(
              (m) => m?.isViceCaptain
            );

            return (
              <Form className="w-full flex-col align-left justify-start g-1">
                <FormInput
                  name="teamName"
                  label="Name of the team"
                  placeholder="Enter a name for this team"
                  touched={touched}
                  errors={errors}
                  containerClass={"w-full"}
                />
                <FormInput
                  name="workingField"
                  label="Working field"
                  placeholder="Enter working field"
                  touched={touched}
                  errors={errors}
                  containerClass={"w-full"}
                />
                <div className="teamInfoMemberListSliderParent">
                  <ul className="teamInfoMemberList">
                    {values?.teamMembers?.map((item, index) => (
                      <li key={item.id}>
                        <div className="flex-row align-left justify-start w-full g-05">
                          <span className="t-13 poppins color-textColor">
                            {index + 1}
                          </span>
                          <div className="teamMemberListProfiles">
                            <ProfileViewer
                              imageHeight={"3rem"}
                              imageWidth={"3rem"}
                              imageSource={item.image}
                              name={
                                item.name.split(" ")[0] +
                                " " +
                                (item.name.split(" ")[1] || "")
                              }
                              _id={item.id}
                              designation={item.designation}
                            />

                            <div className="flex-row align-center justify-end">
                              {item.isCaptain && <BatchIcon fill={"#FFBB00"} />}
                              {item.isViceCaptain && (
                                <BatchIcon fill={"#3FB5FF"} />
                              )}
                              {!item.isCaptain &&
                                !item.isViceCaptain &&
                                !isCaptainSelected && (
                                  <button
                                    type="button"
                                    onClick={() => handelSetCaptain(item.id)}
                                  >
                                    Captain
                                  </button>
                                )}

                              {!item.isCaptain &&
                                !item.isViceCaptain &&
                                isCaptainSelected &&
                                !isViceCaptainSelected && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handelSetViceCaptain(item.id)
                                    }
                                  >
                                    Vice cap
                                  </button>
                                )}

                              {!item.isCaptain &&
                                !item.isViceCaptain &&
                                isCaptainSelected &&
                                isViceCaptainSelected && (
                                  <BatchIcon fill={"#A9A9A9"} /> // Gray icon
                                )}
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  type="button"
                  className="actionBtn w-full"
                  onClick={() => {
                    setModalStatus(true);
                    setInitialData(values);
                  }}
                >
                  {values?.teamMembers?.length === 0
                    ? "Choose members"
                    : "Choose another"}
                </button>
                {values?.teamMembers?.length > 0 && (
                  <button type="submit" className="actionBtn w-full">
                    {!isNewFields ? "Update" : "Create"}
                  </button>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default TeamInfoForm;
